import {NgModule} from '@angular/core';

import {RichTextComponent} from './rich-text/rich-text.component';

@NgModule({
  declarations: [RichTextComponent],
  exports: [RichTextComponent],
})
export class RichTextModule {}
